import { createAction } from 'redux-actions';
import { combineReducers } from 'redux';
import firebase from 'firebase';

// Constants
export const ALL_INFOGRAPHICS_RESULT = 'infographics/ALL_INFOGRAPHICS_RESULT';
export const CREATE_INFOGRAPHIC = 'infographics/CREATE_INFOGRAPHIC';
export const EDIT_INFOGRAPHIC = 'infographics/EDIT_INFOGRAPHIC';
export const REMOVE_INFOGRAPHIC = 'infographics/REMOVE_INFOGRAPHIC';

// Reducer
const initialState = [];

const infographics = (state = initialState, action) => {
  switch (action.type) {
    case ALL_INFOGRAPHICS_RESULT:
      return action.payload;
    case CREATE_INFOGRAPHIC:
      return [...state, action.payload];
    case EDIT_INFOGRAPHIC:
      return state.map(infographic => {
        if (infographic.key === action.payload.key) {
          return action.payload;
        }
        return infographic;
      });
    case REMOVE_INFOGRAPHIC:
      return state.filter(infographic => infographic.key !== action.payload);
    default:
      return state;
  }
};

const syncer = (state = false, action) => {
  switch (action.type) {
    case ALL_INFOGRAPHICS_RESULT:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  infographics,
  syncer,
});

// Action creators
export const allInfographicsResults = createAction(ALL_INFOGRAPHICS_RESULT);
export const createInfographic = createAction(CREATE_INFOGRAPHIC);
export const editInfographic = createAction(EDIT_INFOGRAPHIC);
export const removeInfographic = createAction(REMOVE_INFOGRAPHIC);

export const listenToInfographics = () => async (dispatch, getState) => {
  const ref = firebase.database().ref('infographics');
  const snap = await ref.once('value');
  const { auth: { uid } } = getState();
  const allInfographics = [];
  snap.forEach(s => {
    const infographic = s.val();
    if (infographic.creator.uid === uid || infographic.isPublic) {
      allInfographics.push({
        ...infographic,
        key: s.key,
      });
    }
  });
  dispatch(allInfographicsResults(allInfographics));
  ref.on('child_added', s => {
    const infographic = s.val();
    if (infographic.creator.uid === uid || infographic.isPublic) {
      if (!getState().infographics.infographics.find(c => c.key === s.key)) {
        dispatch(createInfographic({ ...infographic, key: s.key }));
      }
    }
  });

  ref.on('child_changed', s => {
    const infographic = s.val();
    if (infographic.creator.uid === uid || infographic.isPublic) {
      dispatch(
        editInfographic({
          ...infographic,
          key: s.key,
        })
      );
    }
  });

  ref.on('child_removed', s => {
    dispatch(removeInfographic(s.key));
  });
};



// WEBPACK FOOTER //
// ./src/modules/infographics/Infographics.js